import { message } from "antd"

export function messageProgress(content, key = "", duration = 10000000000) {
  message.loading({
    content,
    key,
    duration,
  })
}

export function messageSuccess(content, key = "", duration = 5) {
  message.success({
    content,
    key,
    duration,
  })
}

export function messageFailed(content, key = "", duration = 5) {
  message.error({
    content,
    key,
    duration,
  })
}

export function messageDestroy() {
  message.destroy()
}
